export default {
    type: "form-field-validator-pattern",
    name: "form-field-validator-pattern-lower-case",
    pattern: {
        name: "lowerCase",
        regex: `^([a-z]*)$`,
        flags: ""
    }
};
